<template>
    <Chart  @getData='getData'>
        <template #v>
            <div id="echart_four_one"></div>
        </template>
    </Chart>
</template>

<script>
import Chart from "../components/chart";
export default {
    name: "",
    data() {
        return {

        };
    },
    methods: {
        getData(plan,echarts,times) {
            let { axis,grid,title,legend } = plan

            let option = {
                color: ['#2075d2','#352d9a','#4cbea4'],
                title: {
                    text: "近八年三大产业生产总值对比",
                    ...title,
                },
                legend: {
                    ...legend,
                    data: [],
                    right: 20,
                    top: 30,
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },
                },
                grid,
                xAxis: {
                    name: "年",
                    type: "category",
                    data: [],
                    ...axis,
                },
                yAxis: {
                    name: "",
                    ...axis,
                },
                series: [],
            };
            var url =
                this.urlobj.dx_jjfxty +
                `?tableName=rlt_40year_item_value&times=${times}&itemid=5,6,7`;
            this.$get(url).then((res) => {
                let data = res.rows[0].data;
                option.yAxis.name = data[0].dataArr[0].units
                let x = data[0].dataArr.map((item) => item.name);
                option.legend.data = x;
                let color = ['#2453a3','#322f96','#23657d',]
                option.series = x.map((item,index) => {
                    return {
                        name: item,
                        data: [],
                        type: "line",
                        symbol: "none",
                        smooth:true,
                        areaStyle: {
                            color: color[index]
                        }
                    };
                });
                let arr = [];
                data.forEach((item) => {
                    option.xAxis.data.push(item.time);
                    let obj = {};
                    item.dataArr.forEach((itemx) => {
                        obj[itemx.name] = itemx.value;
                    });
                    arr.push(obj);
                });
                option.series.forEach((item) => {
                    arr.forEach((itemx) => {
                        item.data.push(itemx[item.name]);
                    });
                });

                var myChart = echarts.init(
                    document.getElementById("echart_four_one")
                );

                myChart.setOption(option);

                
            });
        },
    },
    created() {

    },
    components: {
        Chart,
    },
};
</script>

<style lang="less" scoped>
#echart_four_one {
    height:250px;
    &::before {
        background-image: url("../../../assets/dongxiang/beft.png");
        position: absolute;
        content: "";
        display: block;
        left: -7px;
        bottom: -7px;
        width: 38px;
        height: 38px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }
}
</style>
